import { useEffect, useState } from "react";
import { localDateTime } from "../../lib/datetime";
import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { getPenalty } from "../../api/penalties";
import { ConfirmDialog } from "./ConfirmDialog";

const ROWS = ["serial_number", "penalty_type", "reason_category", "reason_details", "deduction_days",
  "deduction_amount", "currency", "status", "effective_date", "final_settlement", "advance_deducted",
  "debt_amount", "debt_number", "journal_entry_number", "legal_action", "progressive_override",
  "progressive_override_reason", "created_by_name", "created_at", "approved_at", "rejection_reason"];

const ENUM = { penalty_type: "types", reason_category: "reasons", status: "status" };
const BOOLS = ["advance_deducted", "legal_action", "progressive_override"];
const DATES = ["created_at", "approved_at"];

const fmt = (t, key, v) => {
  if (ENUM[key]) return t(`penalty.${ENUM[key]}.${v}`, String(v));
  if (BOOLS.includes(key)) return v ? t("common.yes", "نعم") : t("common.no", "لا");
  if (DATES.includes(key)) return localDateTime(v);
  return String(v);
};

// نافذة تفاصيل العقوبة مع سجل التدقيق الكامل.
export const PenaltyDetail = ({ penaltyId, onClose, isAdmin, onCancel, onDelete }) => {
  const { t } = useTranslation();
  const [doc, setDoc] = useState(null);
  const [confirm, setConfirm] = useState(null);

  useEffect(() => {
    if (penaltyId) getPenalty(penaltyId).then(setDoc);
  }, [penaltyId]);

  if (!penaltyId) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-background/80 p-4"
         data-testid="penalty-detail-modal" onClick={onClose}>
      <NeuCard className="grid max-h-[90vh] w-full max-w-2xl gap-3 overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-base font-black">{t("penalty.detail.title")}</h3>
        <div className="grid gap-1 sm:grid-cols-2">
          {ROWS.filter((key) => doc && doc[key] !== null && doc[key] !== undefined && doc[key] !== "" && doc[key] !== false).map((key) => (
            <div key={key} className="flex items-center justify-between gap-2 border-b border-border/30 py-1">
              <span className="text-[11px] text-muted-foreground">{t(`penalty.detail.${key}`, key)}</span>
              <span className={`num text-xs font-bold ${key === "final_settlement" ? "text-success" : ""}`}>{fmt(t, key, doc[key])}</span>
            </div>
          ))}
        </div>
        <h4 className="text-sm font-black">{t("penalty.detail.audit")}</h4>
        <ul className="grid gap-1" data-testid="penalty-detail-audit">
          {(doc?.audit || []).map((row) => (
            <li key={row.id} className="text-[11px] text-muted-foreground">
              <span className="num font-mono" dir="ltr">{localDateTime(row.at)}</span>
              {" · "}{t(`penalty.audit.${row.kind}`, row.kind)}{" · "}{row.actor_name}
            </li>
          ))}
          {!(doc?.audit || []).length ? (
            <li className="text-[11px] text-muted-foreground">{t("penalty.detail.noAudit")}</li>
          ) : null}
        </ul>
        <div className="flex flex-wrap items-center gap-2">
          {isAdmin && doc?.status === "approved" ? (
            <NeuButton className="px-4 py-2 text-xs font-bold text-warning" data-testid="penalty-detail-cancel" onClick={() => setConfirm("cancel")}>
              {t("penalty.actions.cancel")}
            </NeuButton>
          ) : null}
          {isAdmin ? (
            <NeuButton className="px-4 py-2 text-xs font-bold text-destructive" data-testid="penalty-detail-delete" onClick={() => setConfirm("delete")}>
              {t("penalty.actions.delete")}
            </NeuButton>
          ) : null}
          <NeuButton className="ms-auto px-4 py-2 text-xs" data-testid="penalty-detail-close" onClick={onClose}>{t("common.close")}</NeuButton>
        </div>
        <ConfirmDialog open={confirm === "cancel"} title={t("penalty.confirm.cancelTitle")} body={t("penalty.confirm.cancelBody")}
                       confirmLabel={t("penalty.confirm.cancelYes")} onConfirm={() => { setConfirm(null); onCancel(); }} onCancel={() => setConfirm(null)} />
        <ConfirmDialog open={confirm === "delete"} title={t("penalty.confirm.deleteTitle")} body={t("penalty.confirm.deleteBody")}
                       confirmLabel={t("penalty.confirm.deleteYes")} onConfirm={() => { setConfirm(null); onDelete(); }} onCancel={() => setConfirm(null)} />
      </NeuCard>
    </div>
  );
};
